import api from '@/api/_kine-clinical'
import { clinicNow } from './kine-clinical-time'

export const tabs = [
    { value: 'aujourdhui', label: 'Aujourd’hui' }, { value: 'en_cours', label: 'En rééducation' },
    { value: 'a_planifier', label: 'À planifier' }, { value: 'terminees', label: 'Terminées' }
]
export const states = {
    en_cours: 'Séance en cours', payee: 'Séance payée — en file',
    planifiee_payee_avance: 'Planifiée — payée d’avance', planifiee_attente_caisse: 'Planifiée — passage en caisse attendu',
    heure_a_fixer: 'Heure à fixer par l’accueil', absent: 'Patient absent', annule: 'Rendez-vous annulé',
    a_planifier: 'À planifier', terminee: 'Rééducation terminée'
}
export const totalSessions = row => Number(row.seances_prescrites || 0) + Number(row.seances_ajoutees || 0)
export function nextSessionDate(frequency, zone, date = new Date()) {
    const today = clinicNow(date, zone).slice(0, 10)
    const text = String(frequency || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
    const days = /quotidien|chaque jour|tous les jours/.test(text) ? 1 : /^\s*3\s*(?:×|x|fois)/.test(text) ? 2
        : /^\s*2\s*(?:×|x|fois)/.test(text) ? 3 : /^\s*1\s*(?:×|x|fois)/.test(text) ? 7 : null
    if (!days) return ''
    const civil = new Date(today + 'T12:00:00Z')
    civil.setUTCDate(civil.getUTCDate() + days)
    return civil.toISOString().slice(0, 10)
}
export function actionFor(row) {
    const state = (row.prochaine || {}).etat
    if (state === 'en_cours') return 'Continuer'
    if (state === 'payee') return 'Commencer la séance ' + (Number(row.faites || 0) + 1)
    if (['absent', 'annule', 'planifiee_attente_caisse', 'heure_a_fixer', 'planifiee_payee_avance'].includes(state)) return 'Replanifier'
    return state === 'a_planifier' ? 'Planifier' : 'Ouvrir le dossier'
}
export function message(error) {
    const data = error && error.response && error.response.data
    return data && data.message || error && error.message || 'Le suivi par séances est indisponible. Réessayez.'
}
export async function clinicalToken(current = () => true) {
    const response = await api.getAccess()
    if (!current()) throw Error('Le contexte a changé. Aucune opération n’a été envoyée.')
    const data = response && response.data
    if (!response || response.success !== true || !data || !data.access_token) throw Error('L’autorisation Kiné est indisponible. Réessayez.')
    return data.access_token
}
export async function openReeducation(id, token, current = () => true) {
    const response = await api.getConsultationReeducation(id, token)
    if (!current()) return null
    const data = response.data
    if (!data || !data.suivi_par_seances) return { candidates: [], reeducation: null }
    if (data.rattachee) return { candidates: [], reeducation: data.rattachee, numero: data.numero }
    const candidates = data.candidates || []
    if (candidates.length !== 1) return { candidates, reeducation: null }
    const attached = await api.attachReeducation(id, candidates[0].id, token)
    return current() ? { candidates: [], reeducation: attached.data.reeducation, numero: attached.data.numero } : null
}
export function validateDecision(data, extend) {
    const motif = String(data.motif || '').trim()
    if (motif.length < 5 || motif.length > 500) return 'Renseignez un motif de 5 à 500 caractères.'
    if (extend && (!Number.isInteger(Number(data.seances)) || Number(data.seances) < 1 || Number(data.seances) > 50)) return 'Choisissez de 1 à 50 séances.'
    if (!extend && !['terminee', 'interrompue'].includes(data.statut)) return 'Choisissez Terminer ou Interrompre.'
    return ''
}
